import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectIsSobCompetitorCommentLoading = createSelector(
  [selectCompetitorsSobState],
  ({ commentStatus }) => commentStatus === RequestStatus.PENDING
)
